const settings = {
  channels: [
    {
      channel: 'Folkofolk SE',
      store: 'folkofolk_se',
      locale: 'sv-SE',
      languageCode: 'sv',
      slugs: {
        ContentfulArticlePage: 'artiklar',
        ContentfulCampaign: 'campaign',
        MagentoProduct: 'drycker',
      },
    },
  ],
  localization: {
    default: 'sv-SE',
    defaultLanguageCode: 'sv',
  },
  seo: {
    noIndex: ['/kampanj/'],
  },
};

export default settings;
